<template>
	<div v-if="showFab">
		<v-btn
			class="next-btn"
			:style="{ display: showFab ? '' : 'none' }"
			:color="value ? buttonColor : buttonAltColor"
			depressed
			fixed
			right
			fab
			@click="value ? next() : undefined"
		>
			<v-icon v-if="value" color="white">fa-arrow-right</v-icon>
			<slot v-else name="icon-alt" />
		</v-btn>

		<tippy
			v-if="showTooltip"
			to-selector=".next-btn"
			placement="left"
			v-bind="tooltipAttrs"
			arrow
		>
			<slot v-if="value" name="tooltip" />
			<slot v-else name="tooltip-alt" />
		</tippy>
	</div>
</template>

<style lang="scss" scoped>
.next-btn {
	bottom: $first-fab-bottom;
}
</style>

<script>
export default {
	props: {
		value: {
			type: Boolean,
			default: false,
		},

		next: {
			type: Function,
			required: true,
		},

		buttonColor: {
			type: String,
			default: "ocean",
		},

		buttonAltColor: {
			type: String,
			default: undefined,
		},
	},

	computed: {
		showFab() {
			return this.value || this.$slots["icon-alt"];
		},

		showPrimaryTT() {
			return this.value && this.$slots["tooltip"];
		},

		showAltTT() {
			return (
				!this.value && this.$slots["icon-alt"] && this.$slots["tooltip-alt"]
			);
		},

		showTooltip() {
			return this.showPrimaryTT || this.showAltTT;
		},

		tooltipAttrs() {
			return {
				// Hide on click should be false when showing persistant tooltip
				hideOnClick: !this.showPrimaryTT,
				trigger: this.showPrimaryTT ? "manual" : "mouseenter focus",
				visible: this.showPrimaryTT ? true : undefined,
			};
		},
	},
};
</script>
